/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useSnapshot } from 'valtio';

import Filter from './filter';

import globalRefs from '../managers/globalRefs';
import { appStore, eventsStore, uiStore } from '../managers/globalState';
import { EVENT_CATEGORIES, EVENT_MEDIA } from '../config/constants';
import { filterEvents } from '../helpers/processEvents';

import '../../www/assets/css/event_dropdowns.css';

const EventDropdowns = () => {
	const { getManager } = globalRefs;
	const routeManager = getManager('route');
	// Get the year and category index global state.
	const { events, yearIndex, categoryIndex, mediaIndex, eventsVisibleOnGlobe, eventYears } = useSnapshot(eventsStore.state);
	const { isMobile } = useSnapshot(appStore.state);
	const { isBackButtonVisible } = useSnapshot(uiStore.state);

	const currentYear = eventYears?.[yearIndex];
	const currentCategory = categoryIndex !== null ? Array.from(EVENT_CATEGORIES.keys())[categoryIndex] : 'all';
	const currentFilter = mediaIndex !== null ? Array.from(EVENT_MEDIA.keys())[mediaIndex] : 'all';

	const eventsYear = eventYears?.[yearIndex] || eventYears?.[0];
	const allEventsFromYear = events?.[eventsYear];
	const filteredEvents = allEventsFromYear ? filterEvents(allEventsFromYear, categoryIndex, mediaIndex) : null;

	// When changing the year or the category, it's important to maintain the existing category or year respectively.
	const onYearChange = newYearIndex => {
		const newYear = eventYears[newYearIndex];

		// Navigate to the new event year.
		newYear && routeManager.navigateToEventYear(newYear, currentCategory, currentFilter);
	};

	const onCategoryChange = newCategoryIndex => {
		const newCategoryParam = Array.from(EVENT_CATEGORIES.keys())[newCategoryIndex];

		// Navigate to the new event category.
		newCategoryParam && routeManager.navigateToEventYear(currentYear, newCategoryParam, currentFilter);
	};

	const onMediaChange = newMediaIndex => {
		const newFilterQuery = Array.from(EVENT_MEDIA.keys())[newMediaIndex];

		// Navigate to the new filter query
		newFilterQuery && routeManager.navigateToEventYear(currentYear, currentCategory, newFilterQuery);
	};

	const openEventsOverlay = () => {
		uiStore.setGlobalState({ overlayType: 'events' });
	};

	// Styling
	const floorElements = isBackButtonVisible ? '' : 'floored';

	const showDropdown = eventsVisibleOnGlobe && eventYears && yearIndex !== null;

	return showDropdown && (
		<div className={`events-dropdown-wrapper ${floorElements}`}>
			<div className='num-events-container'>
				{
					isMobile
					&& (
						<button className='event-array-button' onClick={openEventsOverlay}>
							<svg />
						</button>
					)
				}
				<div className='num-events-text'>
					{filteredEvents?.length}
					{' '}
					Event
					{filteredEvents?.length > 1 || filteredEvents?.length === 0 ? 's' : ''}
				</div>
			</div>
			<div className='event-dropdowns-container event-dropdowns-offset'>
				<Filter
					type='dropdown'
					title='السنة'
					allItems={eventYears}
					selectedIndex={yearIndex}
					updateItem={onYearChange}
				/>
				<Filter
					type='dropdown'
					title='الفئة'
					allItems={Array.from(EVENT_CATEGORIES.values())}
					selectedIndex={categoryIndex}
					updateItem={onCategoryChange}
				/>
				<Filter
					type='dropdown'
					title='الوسائط'
					allItems={Array.from(EVENT_MEDIA.values())}
					selectedIndex={mediaIndex}
					updateItem={onMediaChange}
				/>
			</div>
		</div>
	);
};


export default EventDropdowns;
